<template>
  <div class="row justify-center">
    <div class="col-12 col-md-10">
      <h1 class="text-center fz-32 fw-700">
        {{ username }}
      </h1>
      <p class="text-center text-muted">{{ nik }}</p>

      <div class="">
        <p class="text-muted">Riwayat</p>
        <div
          v-for="(item, index) in reports"
          :key="index"
          class="card mb-3 card-hover"
          style="cursor: pointer"
          @click="
            $router.push({
              name: 'HistoryDetail',
              params: { id: item.laporjualid },
            })
          "
        >
          <div class="card-body">
            <div class="d-flex justify-space-between mb-5 mb-md-0">
              <div
                class="d-flex align-center"
                v-if="item.jeniskendaraan == 'MOTOR'"
              >
                <img src="@/assets/ill/il-motor.svg" alt="" />
                <p class="mb-0 ml-3 fw-500">Sepeda Motor</p>
              </div>
              <div class="d-flex align-center" v-else>
                <img src="@/assets/ill/il-car.svg" alt="" />
                <p class="mb-0 ml-3 fw-500">Mobil</p>
              </div>
              <p class="fz-12 text-muted">
                {{ formatDate(item.laporjualdate) }}
              </p>
            </div>
            <div class="d-flex justify-space-between align-items-end">
              <div class="d-flex align-center">
                <img
                  src="@/assets/ill/il-motor.svg"
                  style="opacity: 0"
                  alt=""
                  class="d-none d-md-block"
                />
                <div class="ml-md-3">
                  <p class="mb-0 fw-700 text-gray-4">
                    {{ item.laporjualname }}
                  </p>
                  <p class="mb-0 fz-14 text-gray-4">
                    {{ item.no_pol }}
                  </p>
                </div>
              </div>
              <p
                class="mb-0 text-green fw-700"
                v-if="item.status == 'Pelaporan Berhasil'"
              >
                {{ item.status }}
              </p>
              <p class="mb-0 text-red fw-700" v-else>{{ item.status }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";
export default {
  name: "History",
  data() {
    return {
      username: localStorage.getItem("username"),
      nik: localStorage.getItem("nik"),
    };
  },
  computed: {
    reports() {
      return this.$store.state.main.reports;
    },
  },
  methods: {
    formatDate(date) {
      return moment(date).format("ll");
    },
    formatNomorPolisi(no_pol) {
      return no_pol.substring(0, 3) + " " + no_pol.substring(3);
    },
  },
  created() {
    this.$store.dispatch("VehicleList");
  },
};
</script>
